import React from "react";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { Navigate, useLocation } from "react-router-dom";
import { getAccountInfo, getModules, getProfileID } from "services/localStorage.service";
import { doLogout } from "store/slices/authSlice";
interface Props {
  children: React.ReactNode;
}

const RequireAuth: React.FC<Props> = ({ children }) => {
  const token = useAppSelector((state) => state.auth.token);
  let profileId: number = getProfileID();
  const clientProfileId: number = profileId;
  const location = useLocation();
  const scope = getAccountInfo()?.scopes;
  const module =  getModules();
  const modules = module?.toLowerCase().split(",") || [];
  const currentPath = window.location.pathname;
  const dispatch = useAppDispatch();

  // Define the allowed profile IDs for each screen
  const allowedProfilesByScreen: Record<string, number[]> = {
    '/dashboard': [2,3,4,9],
    '/report': [2,6,9],
    '/client': [2,9],
    '/routes-and-work-schedule': [2,3,4,9],
    '/users': [2,9],
    '/agreement': [2,9],
    '/professional': [2,9],
    '/orders': [3,5,9],
    '/shipment-document': [3,5,7,9],
    '/affiliation': [3,5,9],
    '/warehouse': [6,9],
    '/incoming-soil': [8,9],
    '/vehicles': [9],
    '/work-schedule': [9],
    '/de-affiliation': [9],
    '/garments' : [9],
    '/route' : [9],
  };
  
  const modulePathMapping: Record<string, string> = {
    clients: "/client",
    reports: "/report-v2",
    incomingsoil: "/incoming-soil-v2",
    pendingreturn: "/warehouse-v2",
    routes: "/route",
    workschedules: "/work-schedule",
  };
  // Get the current location from the navigate hook
  const currentLocation = location.pathname;
  if(profileId === 0) profileId = 9; // if profileId is empty then it would be client user the id is 9
  // Check if the current profile ID is allowed for the current screen
  const isProfileAllowed = profileId === 1 || Object.keys(allowedProfilesByScreen).some((allowedRoute) => {
    return currentLocation.startsWith(allowedRoute) && allowedProfilesByScreen[allowedRoute]?.includes(profileId);
  });
  const isModuleAllowed =
    modules.length === 0 ||
    modules.some((module: string) => {
      const mappedPath = modulePathMapping[module] || module;
      return currentLocation.includes(mappedPath);
  });
  // Check if the current scope is allowed for the current screen
  const isScopeAllowed = scope === "Dashboard" && clientProfileId === 0 && currentLocation === "/report-v2/list"
  if (isScopeAllowed) return <Navigate to="/dashboard" replace />;

  const handleUnauthorizedAccess = () => {
    dispatch(doLogout());
    return <Navigate to="/auth/login" replace />;
  }

  if (profileId === 1 && currentPath === "/") {
    handleUnauthorizedAccess()
  }

  return (token && isProfileAllowed && isModuleAllowed) ? <>{children}</> : handleUnauthorizedAccess();
};

export default RequireAuth;
